module.exports = __webpack_public_path__ + "img/18.98eb3cda.svg";